const AppGetterTypes = {
    version: "version",
    validationRules: "validationRules",
    paymentMethods: "paymentMethods",
    getModelValidationRules: "getModelValidationRules",
    getPropertyValidationRules: "getPropertyValidationRules",
    promotion: "promotion",
    checkout: "checkout",
    order: "order",
    genericOrderFailedMessage: "genericOrderFailedMessage",
    pageTitle: "pageTitle"
};

export default AppGetterTypes;
